import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@20.17.9_eslint@9.16.0_jiti@2.4.1__ioredis@5._jwup3q6qwi7gvaxxmtthkfge64/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@20.17.9_eslint@9.16.0_jiti@2.4.1__ioredis@5._jwup3q6qwi7gvaxxmtthkfge64/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}